export function createDefaultContext<T extends object>(): T {
  const handler = {
    get(_target: T, prop: string | symbol) {
      throw new Error(
        `You're trying to access the property "${String(prop)}" on a context which hasn't been provided.`,
      );
    },
  };

  return new Proxy<T>({} as T, handler);
}
